"use client";

import type { TextColor } from "@homeinstead/schemas";

import { cn } from "@homeinstead/ui";
import { inquiryTextColorClass } from "./inquiry-text-color";

type InquiryFieldLabelProps = {
  children: string;
  className?: string;
  htmlFor: string;
  textColor?: TextColor;
};

function InquiryFieldLabel({
  children,
  className,
  htmlFor,
  textColor,
}: InquiryFieldLabelProps) {
  return (
    <label
      className={cn(
        "text-left font-semibold text-base",
        inquiryTextColorClass(textColor),
        className,
      )}
      htmlFor={htmlFor}
    >
      {children}
    </label>
  );
}

export { InquiryFieldLabel };
